import balloon from '../assets/images/apps/Balloon.png';
import bookOfDead from '../assets/images/apps/BookofDead.png';
import crazyTime from '../assets/images/apps/CrazyTime.png';
import fruitsMarket from '../assets/images/apps/fruitsMarketSimulator_iOS.png';
import fruitsTropics from '../assets/images/apps/fruitsFromTropics_iOS.png';
import gonzo from '../assets/images/apps/gonzoQuests_iOS.png';
import olympus from '../assets/images/apps/Olympus.png';
import pinKolages from '../assets/images/apps/pinKolages_iOS.png';
import plinko from '../assets/images/apps/Plinko.png';
import plinkoBlitz from '../assets/images/apps/PlinkoBlitz.png';
import plungeMaster from '../assets/images/apps/PlungeMaster_iOS.png';
import sweetBonanza from '../assets/images/apps/SweetBonanza.png';

export const apps = [
  { image: plinkoBlitz, name: 'Plinko Blitz', platform: 'android' },
  { image: balloon, name: 'Balloon', platform: 'android' },
  { image: plinko, name: 'Plinko', platform: 'android' },
  { image: crazyTime, name: 'Crazy Time', platform: 'android' },
  { image: sweetBonanza, name: 'Sweet Bonanza', platform: 'android' },
  { image: olympus, name: 'Olympus', platform: 'android' },
  { image: bookOfDead, name: 'Book of Dead', platform: 'android' },
  { image: plungeMaster, name: 'Plunge Master', platform: 'ios' },
  { image: pinKolages, name: 'Pin Kolages', platform: 'ios' },
  { image: gonzo, name: 'Gonzo Quests', platform: 'ios' },
  { image: fruitsTropics, name: 'Fruits from Tropics', platform: 'ios' },
  { image: fruitsMarket, name: 'Fruits Market Simulator', platform: 'ios' },
];
